export const aboutStats = [
  { icon: "ri-article-line", value: "12,800+", label: "独家爆料" },
  { icon: "ri-user-smile-line", value: "580万+", label: "月活用户" },
  { icon: "ri-fire-line", value: "99.7%", label: "爆料准确率" },
  { icon: "ri-timer-flash-line", value: "7×24", label: "全天候更新" },
];

export const milestones = [
  {
    year: "2018",
    title: "黑料网诞生",
    description: "三位资深娱记联合创立，定位「真实、快速、有料」的娱乐八卦平台，首月即获10万用户关注。",
  },
  {
    year: "2019",
    title: "百万用户里程碑",
    description: "独家爆料体系上线，率先引入「多方信源交叉验证」机制，确保每一条爆料的真实性与可信度。",
  },
  {
    year: "2021",
    title: "内容生态全面升级",
    description: "推出黑料百科、热榜系统、分类导航等功能模块，从单一爆料平台进化为娱乐资讯综合门户。",
  },
  {
    year: "2023",
    title: "AI 赋能内容审核",
    description: "自研「天眼」AI 内容审核系统上线，虚假爆料拦截率达99.7%，成为行业内容可信度标杆。",
  },
  {
    year: "2025",
    title: "月活突破580万",
    description: "覆盖明星、网红、综艺、电竞等全娱乐领域，日均更新爆料200+条，稳居中文娱乐八卦平台第一梯队。",
  },
];

export const testimonials = [
  {
    name: "娱乐小王子",
    avatarInitial: "娱",
    avatarBg: "bg-primary-500",
    role: "资深吃瓜群众 · 4年用户",
    content: "自从用了黑料网，再也不用在微博上翻半天了。爆料又快又准，关键是信息源都标注得清清楚楚，吃瓜吃得明明白白。",
    rating: 5,
  },
  {
    name: "八卦研究所",
    avatarInitial: "八",
    avatarBg: "bg-accent-500",
    role: "自媒体博主 · 3年用户",
    content: "作为内容创作者，黑料网是我的素材宝库。分类清晰、搜索方便，而且每条爆料的时效性都超强，帮我的账号涨了不少粉。",
    rating: 5,
  },
  {
    name: "追星少女小鹿",
    avatarInitial: "鹿",
    avatarBg: "bg-secondary-500",
    role: "追星族 · 2年用户",
    content: "黑料百科太宝藏了！娱乐圈的各种门道和潜规则讲得明明白白，吃瓜也能吃出学问来。每天蹲更新已经成了习惯。",
    rating: 5,
  },
  {
    name: "深夜吃瓜人",
    avatarInitial: "深",
    avatarBg: "bg-primary-600",
    role: "夜猫子用户 · 5年用户",
    content: "见证黑料网从一个小站点成长为娱乐八卦顶流平台。内容质量一直在线，没有像其他平台那样为了流量什么假料都发。",
    rating: 5,
  },
  {
    name: "圈内小白",
    avatarInitial: "圈",
    avatarBg: "bg-accent-600",
    role: "娱乐新人 · 1年用户",
    content: "朋友推荐的黑料网，一开始只是随便看看，结果一看就停不下来了。热榜功能太好用了，每天必刷，比刷短视频还上瘾。",
    rating: 4,
  },
  {
    name: "理性吃瓜bot",
    avatarInitial: "理",
    avatarBg: "bg-secondary-600",
    role: "数据分析师 · 3年用户",
    content: "我是冲着「多方信源交叉验证」来的。黑料网对内容真实性的坚持在八卦圈里真的很难得，这也是我一直留在这里的原因。",
    rating: 5,
  },
];

export const teamValues = [
  {
    icon: "ri-shield-check-line",
    title: "真实可信",
    description: "每条爆料都经过多方信源交叉验证，宁缺毋滥，绝不为了流量发布未经证实的传闻。",
  },
  {
    icon: "ri-flashlight-line",
    title: "快速敏捷",
    description: "7×24小时全天候内容监控，重大爆料15分钟内上线，让你永远快人一步吃上新鲜瓜。",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "有料有深度",
    description: "不只是爆料，更有黑料百科深度解读娱乐现象背后的门道，让你吃瓜吃得明白、吃得专业。",
  },
  {
    icon: "ri-hearts-line",
    title: "吃瓜共同体",
    description: "打造最活跃的吃瓜社区，用户可以参与爆料线索提交、投票验证，每个人都是真相的参与者。",
  },
];